export class StudentAPIBaseError extends Error {}
